export default __webpack_public_path__ + "static/media/PDF_file_icon.ba4a9de7.svg";